<template>
  <div class="container">
    <phone-directory
      :disabled="isEditorDisabled"
      class="phone-directory"
      v-model="directory"
    ></phone-directory>
    <div class="text-right mt-4" v-if="!isEditorDisabled">
      <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
    </div>
  </div>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import PhoneDirectory from "../components/PhoneDirectory";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    PhoneDirectory,
    ScButton
  },
  data() {
    return {
      rawDirectory: [],
      directory: []
    };
  },
  computed: {
    isEditorDisabled() {
      return this.$isCallCenter;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupDirectory();
    },
    async setupDirectory() {
      this.rawDirectory = await this.fetchDirectory();
      this.directory = this.rawDirectory.phone_directory.groups;
    },
    async fetchDirectory() {
      const { id } = this.$route.params;

      const response = await baanRueJaiClient.admin.projects.getPhoneDirectory(
        id
      );

      return response.data.result;
    },
    async handleClickSave() {
      const { id } = this.$route.params;
      const phone_directory = {
        ...this.rawDirectory.phone_directory,
        groups: this.directory
      };
      const params = { phone_directory };

      const response = await baanRueJaiClient.admin.projects.postPhoneDirectory(
        id,
        params
      );

      this.$router.push({ ...this.$route, name: "ProjectDetailPage" });
    }
  }
};
</script>

<style lang="scss" scoped>
.phone-directory {
  margin-top: -30px;
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/projects/pages/ProjectPhoneDirectoryPage.vue